import ReportHeaderBarItems from 'app/common/templates-next/report-template/report-header-bar-items'
import { ReportType } from 'app/dataTypes/reports'

import { History } from 'app/components/common/reports/v3/history'
import { ReportFile } from 'app/components/common/reports/ReportFile/report-file'

const filenameBase = ReportType.FinancesSummary.replace(/-/g, '_')

type Props = {
  reportID: string | null
  reportReady: boolean
}

export const HeaderBar = ({ reportID, reportReady }: Props) => {
  return (
    <ReportHeaderBarItems>
      {reportID && reportReady && <ReportFile reportID={reportID} filenameBase={filenameBase} />}

      <History reportType={ReportType.FinancesSummaryReplenishment} filenameBase={filenameBase} />
    </ReportHeaderBarItems>
  )
}
